import React from 'react';
import PropTypes from 'prop-types';

import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import rectIcon from './rectangle.svg';

const BitRectComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.rect}
    imgSrc={rectIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="R"
  />
);

BitRectComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitRectComponent;
